import type { RouteNameFromPath, TypedRouteLocationRawFromName } from '@typed-router';
import { useLaravelPath } from './useLaravelPath';

export interface NavigationItem {
  label: string;
  icon: string;
  to: TypedRouteLocationRawFromName<RouteNameFromPath<string>> | string;
  id: string;
  external?: boolean;
}

export function useNavigationItems() {
  const runtimeConfig = useRuntimeConfig();
  const { t } = useI18n();
  const localePath = useLocalePath();
  const { homePath } = useHome();
  const laravelPath = useLaravelPath();

  const navigationItems = computed<NavigationItem[]>(() => [
    {
      id: 'home',
      label: t('ui.layout.nav.link.home.label'),
      icon: 'home-variant',
      to: homePath.value as string,
      external: !!runtimeConfig.public.laravelRedirect, // TODO CVO-19899 [Redirect] Remove external: true once this page is released in Veloair
    },
    {
      id: 'trips',
      label: t('ui.layout.nav.link.tripsHistory.label'),
      icon: 'ticket-confirmation',
      to: localePath('/trips'),
    },
    {
      id: 'billing',
      label: t('ui.layout.nav.link.billing.label'),
      icon: 'credit-card',
      to: runtimeConfig.public.laravelRedirect ? laravelPath('/ttw/subscriptions/spa/private-page/billing') : localePath('/billing'), // TODO CVO-19899 [Redirect] Use veloair path once this page is released in Veloair
      external: !!runtimeConfig.public.laravelRedirect, // TODO CVO-19899 [Redirect] Remove external: true once this page is released in Veloair
    },
    {
      id: 'passenger-info',
      label: t('ui.layout.nav.link.account.label'),
      icon: 'account',
      to: localePath('/passenger-info'),
    },
  ]);

  return {
    navigationItems,
  };
}
